import { FormConfig } from '@shared/interfaces/form-configs/form-config';
import {
  AssetType,
  ConnectionType,
  CreateMeteringPointCommand,
  DisconnectionType,
  MeteringPointSubType,
  MeteringPointType,
  NetSettlementGroup,
  ObservationTimeSeriesPeriod,
  ProductCharacteristicIdentification,
  ProductCharacteristicUnitType
} from '@app/api/dmc';

export const meteringPointTypeTemplateProductionQuarterlyFormConfig: FormConfig<CreateMeteringPointCommand> = {
  'detailCharacteristics.meteringPointType': {
    value: MeteringPointType.Production,
  },
  'detailCharacteristics.subType': {
    value: MeteringPointSubType.Virtual,
  },
  'detailCharacteristics.productCharacteristicIdentification': {
    value: ProductCharacteristicIdentification.EnergyActive,
    state: 'required',
  },
  'detailCharacteristics.productCharacteristicUnitType': {
    value: ProductCharacteristicUnitType.KWH,
    state: 'required',
  },
  'detailCharacteristics.fromGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.toGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.netSettlementGroup': {
    state: 'required',
    value: NetSettlementGroup.NetSettlementGroup3,
  },
  'detailCharacteristics.disconnectionType': {
    state: 'required',
    value: DisconnectionType.ManualDisconnection,
  },
  'detailCharacteristics.meterReadingOccurrence': {
    state: 'required',
    value: ObservationTimeSeriesPeriod.Quarter,
  },
  'detailCharacteristics.connectionType': {
    state: 'required',
    value: ConnectionType.InstallationConnected
  },
  'detailCharacteristics.capacity': {
    state: 'required',
  },
  'detailCharacteristics.assetType': {
    state: 'required',
    value: AssetType.PhotovoltaicCells
  },
  'detailCharacteristics.powerPlantIdentification': {
    state: 'optional',
  },
  'parentMeteringPointIdentification': {
    state: 'disabled',
  },
  'connectionPointId': {
    state: 'required',
  },
  // TS-Ignore necessary to reference a field that doesn't exist.
  // @ts-expect-error TS2353: extra property
  'connectionPointIdentification': {
    state: 'required',
    optional: true,
  },
  'connectionPointAddress': {
    state: 'required',
    optional: true,
  }
}
